import { render, staticRenderFns } from "./Occurrence.vue?vue&type=template&id=716c7153"
import script from "./Occurrence.vue?vue&type=script&lang=js"
export * from "./Occurrence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports